import { PostalAddressSchema } from "#gen/google/type/postal_address_pb.js";
import { formattedStreetAddress } from "#lib/address.js";
import { create, type JsonObject } from "#lib/protobuf-compat.js";

export function getDefaultFieldTitle(name: string) {
	return (name[0].toUpperCase() + name.substring(1)).replaceAll("_", " ");
}

export function getDefaultTextValue(v?: JsonObject): string {
	return (v?.value as string)?.trim() ?? "";
}

export function getDefaultTextAsStruct(v?: string | string[]): JsonObject | undefined {
	return v?.length ? { value: v } : undefined;
}

export function getDefaultAddressAsText(v?: JsonObject): string {
	if (!v || !("value" in v)) {
		return "";
	}
	const address = v.value as Record<string, string>;
	const lines = [address.address1] as string[];
	if (address.address2) {
		lines.push(address.address2);
	}

	return formattedStreetAddress(
		create(PostalAddressSchema, {
			addressLines: lines,
			locality: address.city,
			administrativeArea: address.zone,
			postalCode: address.postalCode,
			regionCode: address.country,
		}),
	);
}

export function getChoiceAsText(v?: string | string[]): string {
	if (v == null) {
		return "";
	}
	return Array.isArray(v) ? v.join(", ") : v;
}
